import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '@synegen/utility';

export function adminPermissionGuard(...permissions: string[]): CanActivateFn {
  return (route, state) => {
    const auth = inject(Auth);
    const router = inject(Router);

    if (!auth.isAuthenticated()) {
      return router.createUrlTree(['/login'], {
        queryParams: { returnUrl: state.url },
      });
    }

    const isAdmin = auth.hasAuthority('system:role:admin');
    const hasPermission = permissions.length === 0 || auth.hasAnyAuthority(...permissions);

    return isAdmin && hasPermission ? true : router.createUrlTree(['/']);
  };
}
